import React from "react";
import {usePreviewContext} from "../../../context/PreviewContext";
import {DonationContext, DonationContextEntries} from "../../forms/F007ModularDonationForm/types";
import {resolveContext} from "../../forms/F007ModularDonationForm/utils";
import {createContext, createProductType} from "../../forms/F007ModularDonationForm/utils/donationInitializerFunctions";
import CCOCard from "../../fundamentals/CCOCard";
import {metaDataElementWithId} from "../../preview/previewMetaData";
import {SosDonationCardType} from "../../types";
import C086DonationCardTeaserCardContent from "./C086DonationCardTeaserCardContent";


interface Props {
    item: SosDonationCardType;
    horizontal?: boolean;
}

function C086DonationCardTeaser(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    const productType = createProductType(props.item.donationSettings?.custom?.productType);
    const donationSettings: DonationContextEntries = {};
    Object.entries(props.item.donationSettings?.custom?.donationContext).forEach(([key, value]) => {
        donationSettings[key as DonationContext] = createContext(value, props.item?.donationSettings?.default?.donation_context?.[key], props.item, undefined);
    });
    // in teaser can only one context be shown, in case the product type has more contexts, show only the first one
    const donationContext = resolveContext(productType.donationType[0], productType.donationRhythm[0], productType.sponsorshipType ? productType.sponsorshipType[0] : undefined,  donationSettings);

    function getTarget() {
        const params = new URLSearchParams(
            Object.entries({
                cmCsId: props.item.id,
                amount: String(donationContext?.defaultAmount)
            })
        ).toString();
        // Replace '+' (used for spaces in URL encoding by URLSearchParams) with '%20' for proper space representation.
        const encodedParams = params.replace(/\+/g, '%20');
        return `${props.item.selfUrl}?${encodedParams}`;
    }
    if (props.item != null) {
        return <CCOCard customLink={getTarget()} dataCypress="donationCardTeaser" item={props.item}
                        padding={0}
                        hasFocusedStyle {...metaDataElementWithId(isPreview, props.item.id)}>
            <C086DonationCardTeaserCardContent item={props.item} horizontal={props.horizontal} buttonLabel={donationContext?.buttonLabel} />
        </CCOCard>;
    } else {
        return null;
    }

}

export default C086DonationCardTeaser;
